import React, { useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { ChatArea } from './components/ChatArea';
import { mockChats, mockProjects } from './mockData';
export function App() {
  const [activeChatId, setActiveChatId] = useState<string | null>(null);
  const activeChat = activeChatId ? mockChats.find(c => c.id === activeChatId) || null : null;
  const handleNewChat = () => {
    setActiveChatId(null);
  };
  return <div className="dark flex h-screen w-full bg-[#141620] text-slate-200 font-sans overflow-hidden" data-id="element-0">
      <Sidebar chats={mockChats} projects={mockProjects} activeChatId={activeChatId} onSelectChat={setActiveChatId} onNewChat={handleNewChat} data-id="element-1" />
      <main className="flex-1 flex flex-col h-full overflow-hidden bg-[#141620]" data-id="element-2">
        <ChatArea activeChat={activeChat} data-id="element-3" />
      </main>
    </div>;
}